import {useCallback} from 'react';
import {useAuthStateManager} from '../hooks/useAuthStateManager';

export function useCreateAuthenticatedFetch() {
    const {getAccessToken} = useAuthStateManager();

    return useCallback(
        async (url: string, options: RequestInit = {}): Promise<Response> => {
            const headers = new Headers(options.headers);
            const accessToken = await getAccessToken();

            if (accessToken && accessToken !== '') {
                headers.set('Authorization', `Bearer ${accessToken}`);
            }

            headers.set(
                'IANA-TimeZoneId',
                Intl.DateTimeFormat().resolvedOptions().timeZone
            );

            const response = await fetch(url, {
                ...options,
                headers,
                credentials: 'include'
            });

            return response;
        },
        [getAccessToken]
    );
}
